import React from 'react';

const EyeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16' fill='none'>
      <path
        d='M9.92554 3.5C11.7738 3.50027 13.4607 5.29034 13.4607 7.75C13.4607 10.2097 11.7738 11.9997 9.92554 12C8.07712 12 6.3894 10.2098 6.3894 7.75C6.3894 5.29016 8.07712 3.5 9.92554 3.5Z'
        stroke='white'
        stroke-width='1.5'
      />
      <path
        d='M9.9251 0C12.2006 0 14.1928 1.11682 15.7652 2.51074C17.3373 3.90444 18.5314 5.61095 19.2298 6.88965C19.5105 7.40381 19.5283 8.05885 19.2658 8.59375C18.0255 11.1203 14.7637 15.5 9.9251 15.5C5.12972 15.5 1.63208 11.1919 0.22867 8.6748C-0.0915341 8.1005 -0.0719813 7.36472 0.2655 6.81348C1.04578 5.539 2.33829 3.85134 3.98286 2.47559C5.62578 1.10129 7.66645 0 9.9251 0ZM9.9251 1.5C8.02657 1.5 6.24483 2.42888 4.73202 3.69434C3.22122 4.95817 2.02421 6.52055 1.31098 7.68555C1.27728 7.74091 1.27778 7.80688 1.30596 7.85742C2.62488 10.2229 5.78537 14 9.9251 14C14.0765 14 16.9982 10.1947 18.15 7.84863C18.1722 7.80336 18.1729 7.74505 18.1458 7.69531C17.5145 6.53942 16.418 4.97389 14.9868 3.70508C13.5558 2.43659 11.8312 1.5 9.9251 1.5Z'
        fill='white'
      />
    </svg>
  );
};

export default EyeIcon;
